import { useEffect } from 'react';
import { DfcSurface } from '../../../../Utils/dfcSurface';

/**
 * Paints the document with the village surface while the village header is mounted, so the
 * area past the content (short pages, iOS overscroll) and native controls — scrollbars, form
 * pickers — follow light / dark too. Restored on unmount, so no other theme is affected.
 */
const useDfcDocumentSurface = (surface: DfcSurface) => {
  useEffect(() => {
    const root = document.documentElement;
    const { body } = document;
    const previous = { scheme: root.style.colorScheme, background: body.style.background };

    root.style.colorScheme = surface.dark ? 'dark' : 'light';
    body.style.background = surface.pageBg;

    return () => {
      root.style.colorScheme = previous.scheme;
      body.style.background = previous.background;
    };
  }, [surface]);
};

export default useDfcDocumentSurface;
